import { BridgeInstance } from '../../instance';
import { ConvertAmountRangeRes } from './types';
import { ChainSymbol } from '../../../datas/chains';
import { TokenSymbol } from '../../../datas/tokens';

const SUB_URL = `/cryptocurrencies`;

export const getCryptocurrencyAmountRangeById = (id: number) =>
  BridgeInstance.get<ConvertAmountRangeRes>(`${SUB_URL}/${id}`).then(
    (res) => res.data,
  );

export const getConvertAmountRangeAll = () =>
  BridgeInstance.get<ConvertAmountRangeRes[]>(`${SUB_URL}`).then(
    (res) => res.data,
  );

export const getCryptoCurrencyWithSymbol = (
  chainSymbol: ChainSymbol,
  tokenSymbol: TokenSymbol,
) =>
  BridgeInstance.get<ConvertAmountRangeRes>(
    `${SUB_URL}/symbols/${chainSymbol}/${tokenSymbol}`,
  ).then((res) => res.data);
